import {Editor as MonacoEditor, EditorProps as MonacoEditorProps} from "@monaco-editor/react";

export type EditorProps = MonacoEditorProps & {
  // extend props here
}

export const Editor = (props: EditorProps) => {
  const {...rest} = props;
  return <MonacoEditor {...rest} />;
}
